import { loadPresets } from "../../lib/loadPresets";
import * as actions from "./actions";
import { ActionType, getType } from "typesafe-actions";
import { BookDirectOrder } from "./model/BookDirectOrder";
import { BookDirectState } from "./model/BookDirectState";
import { combineReducers } from "redux";
import { TimeWindowValidator } from "../../lib/validators/TimeWindowValidator";
import { LoadValidator } from "../../lib/validators/LoadValidator";

const timeWindowValidator = new TimeWindowValidator();
const loadValidator = new LoadValidator();

export type BookDirectAction = ActionType<typeof actions>;

const initialOrder: BookDirectOrder = {
  date: undefined,
  startAddress: {},
  endAddress: {},
  startWindow: [7, 17],
  endWindow: [7, 17],
  loads: [loadPresets[0]],
  extras: [],
  comment: undefined,
  internalReference: undefined,
  pickupComment: undefined,
  dropoffComment: undefined
};

export default combineReducers<BookDirectState, BookDirectAction>({
  order: (state = initialOrder, action) => {
    switch (action.type) {
      case getType(actions.updateOrder):
        const minStartingTime = action.payload.date
          ? timeWindowValidator.minStartTime(action.payload.date)
          : 5;
        const validStartWindow = timeWindowValidator.validTimeWindowFromTimeWindow(
          action.payload.startWindow,
          minStartingTime
        );
        const validEndWindow = timeWindowValidator.validTimeWindowFromTimeWindow(
          action.payload.endWindow,
          validStartWindow[0]
        );
        const loads = loadValidator.validLoads(action.payload.loads);
        return {
          ...action.payload,
          startWindow: validStartWindow,
          endWindow: validEndWindow,
          loads
        };
      case getType(actions.resetOrder):
        return initialOrder;
      default:
        return state;
    }
  },
  isLoadingQuote: (state = false, action) => {
    switch (action.type) {
      case getType(actions.fetchQuoteAsync.request):
        return true;
      case getType(actions.fetchQuoteAsync.success):
        return false;
      case getType(actions.fetchQuoteAsync.failure):
        return false;
      default:
        return state;
    }
  },
  isLoadingCreate: (state = false, action) => {
    switch (action.type) {
      case getType(actions.createOrderAsync.request):
        return true;
      case getType(actions.createOrderAsync.success):
        return false;
      case getType(actions.createOrderAsync.failure):
        return false;
      default:
        return state;
    }
  },
  createdOrder: (state = null, action) => {
    switch (action.type) {
      case getType(actions.createOrderAsync.success):
        return { ...action.payload };
      case getType(actions.resetOrder):
        return null;
      default:
        return state;
    }
  },
  quote: (state = null, action) => {
    switch (action.type) {
      case getType(actions.resetQuote):
      case getType(actions.resetOrder):
        return null;
      case getType(actions.fetchQuoteAsync.success):
        return action.payload;
      case getType(actions.fetchQuoteAsync.failure):
        return null;
      default:
        return state;
    }
  },
  quoteError: (state = null, action) => {
    switch (action.type) {
      case getType(actions.fetchQuoteAsync.request):
      case getType(actions.fetchQuoteAsync.success):
      case getType(actions.resetOrder):
        return null;
      case getType(actions.fetchQuoteAsync.failure):
        return action.payload;
      default:
        return state;
    }
  },
  createError: (state = null, action) => {
    switch (action.type) {
      case getType(actions.createOrderAsync.request):
      case getType(actions.createOrderAsync.success):
      case getType(actions.resetOrder):
        return null;
      case getType(actions.createOrderAsync.failure):
        return action.payload;
      default:
        return state;
    }
  }
});
